import { Course } from "@core/domain/course";

export interface Courses {
  courses: Course[];
}

export enum ExamComponentType {
  MANDATORY = "V", // Verplicht
  MANDATORY_CHOICE = "VK", // Verplichte keuze
  CHOICE = "K", // Keuze
  ELECTIVES = "P", // Profileringsruimte
  SPECIALISATION = "S", // Specialisatie
}

export enum ExamComponentMandatoryChoiceType {
  LIST = "L", // Lijst
  CONDITION = "V", // Vrij veld conditie
  NOT_APPLICABLE = "",
}

export type ExamComponent = {
  id: number;
  label: string;
  labelColor: string;
  type?: ExamComponentType;
  typeMandatoryChoice?: ExamComponentMandatoryChoiceType;
  minimumPoints?: number;
  maximumPoints?: number;
  conditionsMet: boolean;
  conditionsMetMandatoryOrMandatoryChoice: boolean;
  studyProgram?: string;
  examComponentCode: string;
  examComponentName: string;
  examComponentExplanation?: string;
  conditions?: ExamComponentCondition[];
} & Courses;

export interface Minor {
  minor: string;
  name: string;
  examComponents: MinorExamComponent[];
  code: string;
  content: string;
  isEnrolled: boolean;
  minimumPoints: number;
  minorStudyProgram: string;
  studyProgram: string;
}

export type MinorExamComponent = ExamComponent & {
  minorExamComponentCode: string;
  minorExamComponentName: string;
};

export interface ExamComponentForPlanCourse {
  studyProgram: string;
  examComponentCode: string;
  examComponentName: string;
  specialisationProgram: string;
  specialisationName: string;
  minorProgram: string;
  minorName: string;
  color: string;
  type?: ExamComponentType; // empty for "OVERIG" component added in the frontend
  uniqueId?: string; // added in the frontend
}

export interface ExamComponentCondition {
  section: string;
  sectionDescription: string;
  sectionNumber: string;
  freeField: string;
  freeFieldDescription: string;
  content: string;
}
